// extracted by mini-css-extract-plugin
export default {"buySellToggle":"ccI0b","buySellToggle__toggleRadio":"lIVPn","buySellToggle__background":"SYScy","buySellToggle__wrapper":"tAjpG","buySellToggle__button":"iJ1wD"};